var $class="se2--content-introwith-popup-articles--goal-slider",$name="ContentIntrowithPopupArticles/goalSlider",$path="app/components/ContentIntrowithPopupArticles/partials/goalSlider/index.js",$this={$class,$name,$path,};const goalSliderClassName = `${$class}`;

export default goalSliderClassName;
